import { ButtonPosition, ALL_BUTTON_POSITION_LIST, } from '@/common/manager/position/button-position';
import { getArrayTableCurrentRowByField2 } from '@/common/util/util';
import isPlainObject from 'lodash/isPlainObject';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import { __arrayTableCurrentRow__ } from '@/common/util/expr-const';
export const config = {
    value: 'dialog',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config, extra) => {
        const { arrayTableConfig, buttonConfig, _context, position, record, selectedRowKeys, selectedRowRecords, response, arrayTableCurrentRow, formProps, } = config || {};
        const { _dataSourceName } = formProps || {};
        let recordDataSource = record;
        if (position === ButtonPosition.arraySubAreaCardOperate) {
            recordDataSource = arrayTableCurrentRow;
        }
        else if (!record && extra?.field) {
            const { field } = extra;
            const { formItemConfig } = arrayTableConfig || {};
            if (position === ButtonPosition.arrayTableCell) {
                const tempCurrentRow = getArrayTableCurrentRowByField2(field);
                const fieldName = field?.path?.segments?.[0];
                if (fieldName && isPlainObject(tempCurrentRow)) {
                    recordDataSource = cloneDeep(tempCurrentRow);
                    set(_context?.state, `valueOf.${_dataSourceName}.${fieldName}.${__arrayTableCurrentRow__}`, { ...recordDataSource });
                }
            }
            else if (formItemConfig?.name && field) {
                if (field.path.segments.length === 5) {
                    const path = field.path.segments.slice(0, 4);
                    const tempRow = field?.form?.getValuesIn?.(path);
                    if (isPlainObject(tempRow)) {
                        recordDataSource = cloneDeep(tempRow);
                    }
                }
                else {
                    const list = field?.query?.(formItemConfig?.name)?.value?.();
                    if (Array.isArray(list) && list[field?.index]) {
                        recordDataSource = cloneDeep(list[field.index]);
                    }
                }
            }
        }
        if (position === ButtonPosition.tableCellAfterRequestSuccess) {
            recordDataSource = response?.data || {};
        }
        if (buttonConfig && _context) {
            const { options = {} } = buttonConfig;
            const { _bindDialog, setCurrentRowToDialog } = options;
            if (_bindDialog) {
                const dialogNode = _context.$(_bindDialog);
                // let data;
                // if (ButtonPosition.tableOperate === position && dialogNode && _context && record) {
                //   data = record;
                //   const { props = {} } = dialogNode;
                //   const { _dataSourceName } = props;
                //   if (_dataSourceName) {
                //     _context?.setState({
                //       [_dataSourceName]: record,
                //     });
                //   }
                // }
                let realRecordDataSource = recordDataSource;
                if (setCurrentRowToDialog === false) {
                    realRecordDataSource = undefined;
                }
                return new Promise((resolve) => {
                    setTimeout(() => {
                        const p = dialogNode?.open?.(realRecordDataSource, {
                            buttonConfig,
                            position,
                            selectedRowKeys,
                            selectedRowRecords,
                        });
                        if (typeof p?.then === 'function') {
                            p.then(() => {
                                setTimeout(() => {
                                    resolve(true);
                                }, 200);
                            });
                        }
                        else {
                            setTimeout(() => {
                                resolve(true);
                            }, 8);
                        }
                    });
                });
                // table?.load?.();
            }
        }
    },
};
